<div [formGroup]='inputForm' class='container'>
  <h4>Account default email address: {{ emailAddress }}</h4>
  <div class='row'>
    <div class='col col-12'>
      <mat-form-field class='w-100'>
        <mat-label>Notification emails:</mat-label>
        <input
          formControlName='emails'
          matInput
          placeholder='Enter emails separated by commas' />
      </mat-form-field>
    </div>
  </div>
  <div class='row'>
    <div class='col col-12'>
      <mat-checkbox class='w-100' formControlName='notification'
      >Set this at the notification emails address.
      </mat-checkbox
      >
      <mat-checkbox formControlName='forward'
      >Set this as the forward email address.
      </mat-checkbox
      >
    </div>
  </div>
</div>
